
import { useEffect } from "react";
import { useAuth } from "@/components/AuthProvider";
import { useLocation } from "react-router-dom";

export interface OAuthCallbackHandlerProps {
  setIsProcessing: (value: boolean) => void;
  setAuthError: (value: string | null) => void;
}

export function OAuthCallbackHandler({ setIsProcessing, setAuthError }: OAuthCallbackHandlerProps) {
  const location = useLocation();
  const { handleOAuthRedirect } = useAuth();

  useEffect(() => {
    const processAuthRedirect = async () => {
      if ((location.hash && location.hash.includes("access_token")) || 
          location.search.includes("code=")) {
        console.log("OAuth redirect detected, processing...");
        setIsProcessing(true);
        setAuthError(null);
        try {
          await handleOAuthRedirect();
          console.log("OAuth redirect processing completed");
        } catch (error: any) {
          console.error("Error processing OAuth redirect:", error);
          setAuthError(error.message || "Error processing authentication. Please try again.");
        } finally {
          setIsProcessing(false);
        }
      } else {
        console.log("No OAuth redirect parameters detected");
      }
    };
    
    processAuthRedirect();
  }, [location.hash, location.search, handleOAuthRedirect, setIsProcessing, setAuthError]);

  return null;
}
